import React, { ReactNode } from 'react';
import styled, {keyframes} from 'styled-components';

interface BubbleConfig {
  id: number;
  top: number;
  left: number;
  duration: number;
}

const bubbleCount = Math.min(40, Math.floor(window.innerWidth * window.innerHeight / 60000));

const configs: BubbleConfig[] = [];
for (let i = 0; i< bubbleCount; i++) {
  configs.push({
    id: i,
    top: Math.floor(Math.random() * 100),
    left: Math.floor(Math.random() * 100),
    duration: Math.floor(Math.random() * 10) + 1
  })
}

const BlurryBubbles = () => {

  const bubbles: ReactNode[] = configs.map((config) => <Bubble
    key={config.id}
    $top={`${config.top}%`}
    $left={`${config.left}%`}
    $duration={config.duration}
  />);

  return <Container>
    { bubbles }
  </Container>
};

const Screen = keyframes`
  from {
    opacity: 0;
  }

  25% {
    opacity: 0.3;
    transform: scale3d(3, 3, 4);
  }

  50% {
    opacity: 0.75;
  }

  75% {
    opacity: 1;

  }

  to {
    opacity: 0;
  }
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--shine-bg-color);
`;

const Bubble = styled.i<{ $top: string, $left: string; $duration: number}>`
  position: absolute;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  animation: ${Screen} infinite;

  top: ${({ $top }) => $top};
  left: ${({ $left }) => $left};
  background: -webkit-radial-gradient(center, ellipse cover, var(--shine-secondary-bg-color) 0%, rgba(0, 0, 0, 0) 100%);
  box-shadow: 0 0 5px 0 var(--shine-secondary-bg-color);
  animation-duration: ${({ $duration }) => $duration}s;
`;

export default BlurryBubbles;
